await import('/home/ocportal/app/frontend/node_modules/@umijs/bundler-webpack/client/client/client.js');
await import('/home/ocportal/app/frontend/src/.umi/umi.ts');
export default 1;